import { PageModel } from '../../Models/page-model';

export class PageMock {
  private static models: PageModel[];
  private static  idCounter = 0;

  public static initMocks(){
    PageMock.models = [];
    let server="localhost";
    // 18.223.98.43
    PageMock.models.push({_id:"jahjd",desc:"na", name: "Login Screen", pId :++this.idCounter, url:"http://"+server+"/pega/Pages/Login%20Screen.html",webObjects:["iu2gfin32f23","ewhfiuewnfewyy","gffnweftewf7775"]});
    PageMock.models.push({_id:"sverer",desc:"na", name: "Add Team", pId :++this.idCounter, url:"http://"+server+"/pega/Pages/Add%20Team.html",webObjects:[]});
    PageMock.models.push({_id:"tmtmtmt",desc:"na", name: "Case Manager Portal", pId :++this.idCounter, url:"http://"+server+"/pega/Pages/Case%20Manager%20Portal.html",webObjects:[]});
    PageMock.models.push({_id:"bebevtrb",desc:"na", name: "New Item", pId :++this.idCounter, url:"http://"+server+"/pega/Pages/New%20Item.html",webObjects:[]});
    PageMock.models.push({_id:"erbrny",desc:"na", name: "Teams Page", pId :++this.idCounter, url:"http://"+server+"/pega/Pages/Teams%20Page.html",webObjects:["eofoefoefjof"]});
    PageMock.models.push({_id:"jbrttr",desc:"na", name: "Pega Case Manager Portal", pId :++this.idCounter, url:"http://"+server+"/pega/Pages/Pega%20Case%20Manager%20Portal.html",webObjects:[]});
  }

  public static findByObjectId(_id: string):PageModel{
    let m = PageMock.models;
    for(let i = 0; i< m.length; i++){
      if(_id == m[i]._id) return m[i];
    }
    return null;
  }

  public static findById(id:number):PageModel{
    let m = PageMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].pId) return m[i];
    }
    return null;
  }
  public static delete(object):PageModel[]{
    //not working 
    let m = PageMock.models;

    for(let i = 0; i< m.length; i++){
      if(object._id == m[i]._id) {
         m.splice(i,1);
        return m;
        }
    }
    return null;
  }
  public static update(object):PageModel{
    let m = PageMock.models;
    for(let i = 0; i< m.length; i++){
      if(object._id == m[i]._id) {
         m[i]=object;
        return m[i];
      }
    }
    return null;
  }

  public static getItems():PageModel[]{
    return PageMock.models;
  }





}
